(ns motorsaif.web.pages.login
  (:require
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.components :as c]
   [motorsaif.web.lib.form :as form]
   [motorsaif.string :refer [format]]
   [motorsaif.web.svg :as svg]
   [motorsaif.log :as log]
   [motorsaif.validation :as validation]
   [re-frame.core :as rf :refer [dispatch]]))

(defn- login-request [{:keys [all-data]}]
  (let [req
        {:type :POST
         :url     "/api/account/login"
         :params {:data all-data}
         :id :login
         :handler
         (fn [{:keys [success state] :as res}]
           (if success
             (do
               (js/window.location.reload))
             (rf/dispatch [:toast {:type "error"
                                   :message (tr :forms.login.submit.wrong-credentials)}])))
         :error-handler (fn [res]
                          (log/info [:login-error res]))}]

    (rf/dispatch [:do-ajax req])))

(comment
  @(rf/subscribe [:route/page-id])
  @(rf/subscribe [:route/data]))

(defn root []
  (let [page-id @(rf/subscribe [:route/page-id])
        ?email (:email @(rf/subscribe [:route/parameters]))
        init-data {:user/auth-identity ?email
                   ;; :user/password "hello"
                   }
        form-key :login
        {:keys [*data *validated-data form-params input] :as form-args}
        (form/make-form {:schema validation/login
                         ;; :change-watch #(dispatch [:reset-form form-key %])
                         :on-submit {:valid login-request
                                     :invalid (fn [error]
                                                (println "Submit error " error))}
                         :init-data init-data})

        ]
    (fn []
      (when @(rf/subscribe [:user])
        (rf/dispatch [:common/navigate! :home]))
      [:div.root-wrap
       [:div.logo.sm svg/logo]
       [:div.container-sm.card-elevated
        [:h2 (tr :page.login.title)]
        [:form
         form-params

         [input {:placeholder (tr :forms.login.identity-placeholder)}
          [:user/auth-identity]]

         [input {:placeholder (tr :forms.login.password-placeholder)
                 :type "password"}
          [:user/password]]

         [:div.input-wrap
          [:button.btn.primary.full
           {:type "submit"}
           (tr :forms.login.submit.button)]]
         [:hr]
         [:div.flex-center.other-actions
          [:a.btn.primary.clr-brand-secondary.bold
           {:href (routes/path-for :forgot-password)}
           (tr :forms.login.forgot-password)]
          [:a.btn.outline.create {:href (routes/path-for :sign-up)}
           [:span (tr :forms.login.sign-up.new)]
           " "
           [:span.bold.text.clr-brand-secondary
            (tr :forms.login.sign-up.create)]]]
         [:div.or "OR"]
         [:div.flex-center
          [c/google-button :sign-in]]]]])))

(comment
  (rf/dispatch [:verification
                {:email "naomarik@gmail.com"
                 :context :forgot-password}]))
